import angular from 'angular';
import isEmpty from 'lodash/isEmpty';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({
  subComponent: state.statsbar.activeComponent,
  loyaltyStatistics: state.user.loyaltyStatistics,
});

angular
  .module('myConsultApp')
  .controller('deactivateUserController', ($ngRedux, $rootScope, $scope, $http, ENV, $interval, $timeout) => {
    $scope.initData = () => {
      $scope.redemptions = {
        rewards: [],
      };
      $scope.selectedReward = {
        reward: null,
        quantity: '',
      };
      $scope.initialReward = 'Select a Reward';
      $scope.redeemTotal = 0;
      $scope.redeemError = '';
      $scope.errors = [];
      $scope.filterRewards = [];
      $scope.processing_deactivate_user = false;
      $scope.loadingRewards = false;
      $scope.displayRedemptionOption = false;
      $scope.processing_deactivate_user_redemption = false;
      $scope.processing_deactivate_user_redemption_status = '';
      $scope.user_redemption_succeeded = false;
      $scope.pets_to_archive = [];
      $scope.fullRewardsList = [];
      $scope.display_reward_options = true;
      $scope.active_pets = [];
    };

    $scope.init = () => {
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
      $scope.initData();
    };

    $scope.selectArchivePet = (pet_id) => {
      $scope.pets_to_archive.includes(pet_id) ? $scope.pets_to_archive = $scope.pets_to_archive.filter(item => item !== pet_id) : $scope.pets_to_archive.push(pet_id);
    };

    $scope.toggleRedemptionOption = () => {
      $scope.displayRedemptionOption =  $scope.displayRedemptionOption ? false : true;
    }

    $scope.validQuantity = () => {
      $scope.selectedReward.quantity = $scope.selectedReward.quantity.replace(/[^0-9]+/g, '');
    };

    $scope.filterRewardList = () => {
      const userAvailablePoints = $scope.userInfo.redeemable_points - $scope.redeemTotal;
      let uniqueFilterRewardsArray = [];
      angular.forEach($scope.fullRewardsList, function (reward) {
        if (reward.point_cost > userAvailablePoints){
          uniqueFilterRewardsArray = [...uniqueFilterRewardsArray, reward];
        }
      });
      angular.forEach($scope.redemptions.rewards, function (reward) {
        let alreadyExists = false;
        if(uniqueFilterRewardsArray.length) {
          angular.forEach(uniqueFilterRewardsArray, function (existing_reward) {
            if(existing_reward.id == reward.reward.id){
              alreadyExists = true;
            }
          });
        }
        if(!alreadyExists){
          uniqueFilterRewardsArray = [...uniqueFilterRewardsArray, reward.reward];
        }
      });
      $scope.filterRewards = uniqueFilterRewardsArray;
      if(($scope.filterRewards.length + 1) == $scope.fullRewardsList.length){
        $scope.display_reward_options = false;
      } else {
        $scope.display_reward_options = true;
      }
    };

    $scope.addReward = () => {
      if (isEmpty($scope.selectedReward.reward) || !$scope.selectedReward.reward.id) {
        $scope.redeemError = 'Please select a reward.';
        return;
      }
      if (
        Number.isNaN($scope.selectedReward.quantity) ||
        Number($scope.selectedReward.quantity) === 0
      ) {
        $scope.redeemError = 'Please provide a valid quantity.';
        return;
      }

      const newRedeemTotal =
        $scope.redeemTotal +
        Number($scope.selectedReward.reward.point_cost) * Number($scope.selectedReward.quantity);

      if (newRedeemTotal > $scope.userInfo.redeemable_points) {
        $scope.redeemError = 'User does not have enough points to redeem selected reward.';
        return;
      }

      const reward = $scope.selectedReward;
      $scope.redemptions.rewards.push(reward);
      $scope.redeemTotal = newRedeemTotal;
      $scope.filterRewardList();
      $scope.redeemError = '';
      $scope.selectedReward = {
        reward: null,
        quantity: '',
      };
    };

    $scope.removeReward = (index) => {
      const removedReward = $scope.redemptions.rewards[index];
      $scope.redeemTotal -=
        Number(removedReward.quantity) * Number(removedReward.reward.point_cost);
      $scope.redemptions.rewards.splice(index, 1);
      $scope.filterRewardList();
      $scope.errors = [];
    };

    $scope.setRewardList = () => {
      $scope.loadingRewards = true;
      return $scope
        .getRewards($http, ENV, {
          enabled: 'true',
          available_for_order: 'true',
          paginate: false,
          order: 'parent_contentstack_uid,title',
        })
        .then((res) => {
          const userHasCard = $scope?.loyaltyStatistics?.redemption_status?.card_exists;
          $scope.fullRewardsList = res?.rewards?.filter((reward) => {
            // If loyalty statistics redemption_status.card_exists value is false, don’t show “reload card” option on rewards list
            if (reward.reward_type === 'reload_card' && !userHasCard) {
              return false;
            }
            return true;
          });
          $scope.filterRewardList();
          $scope.loadingRewards = false;
          return {
            rewards: $scope.fullRewardsList,
          };
        })
        .catch((e) => {
          $scope.loadingRewards = false;
          console.warn(e);
        });
    };

    $scope.selectReward = (option) => {
      $scope.selectedReward.reward = option;
    };

    $scope.submitDeactivationRedemption = (petsToArchive) => {
      const payload = {
        redemptions: {
          user_id: $rootScope.userId,
          rewards: $scope.redemptions.rewards.map((reward) => ({
            reward_id: reward.reward.id,
            quantity: reward.quantity,
          })),
          usps_validate: false,
        },
      };
      $scope
        .createRedemption($http, ENV, payload)
        .then((res) => {
          $scope.$apply(() => {
            $scope.initData();
            $rootScope.refreshLoyaltyStatistics();
            $rootScope.getData();
            $scope.processing_deactivate_user_redemption = true;
            $scope.pollRedemptionStatus(res['redemptions-group'].redemptions[0].id, petsToArchive);
          });
        })
        .catch((error) => {
          $scope.processing_deactivate_user = false;
          $scope.processing_deactivate_user_redemption = false;
          $scope.processing_deactivate_user_redemption_status = '';
          if (error.data['redemptions-groups']) {
            $scope.$apply(() => {
              $scope.errors = error.data['redemptions-groups'];
            });
            return;
          }
          const errors = error.data['redemptions-group'];
          let result = [];
          if (errors) {
            result = Object.keys(errors)
              .map((key) => {
                const keyString = key
                  .split('_')
                  .map((item) => $scope.capitalize(item))
                  .join(' ');
                const value = errors[key];
                if (Array.isArray(value)) {
                  return value.map((x) => `${keyString}: ${x}`);
                }
                return `${keyString}: ${errors[key]}`;
              })
              .flat(1);
          } else {
            result.push('Something went wrong. Please try again.');
          }

          $scope.$apply(() => {
            $scope.errors = result;
          });
        });
    };

    $scope.submitDeactivation = () => {
      $scope.processing_deactivate_user = true;
      if($scope.displayRedemptionOption && $scope.redemptions.rewards.length){
        $scope.submitDeactivationRedemption($scope.pets_to_archive);
      } else {
        $scope.deactivateUser(null, $scope.pets_to_archive);
      }
    };

    let redemptionPromise;
    $scope.pollRedemptionStatus = (redemptionId, petsToArchive) => {
      // if promise exists, cancel it to prevent duplication of intervals
      if (angular.isDefined(redemptionPromise)) {
        $interval.cancel(redemptionPromise);
        redemptionPromise = undefined;
      }
      redemptionPromise= $interval(() => {
        $scope.getRedemptionStatus(redemptionId, petsToArchive);
      }, 6000);
    }

    $scope.getRedemptionStatus = (redemptionId, petsToArchive) => {
      $scope
      .getRedemption($http, ENV, redemptionId)
      .then((res) => {
        $scope.$apply(() => {
          $scope.processing_deactivate_user_redemption_status = res.status.name;
          if (res.status.id == 1){
            $interval.cancel(redemptionPromise);
            redemptionPromise = undefined;
            $scope.processing_deactivate_user_redemption = false;
            $scope.user_redemption_succeeded = true;
            $rootScope.refreshLoyaltyStatistics();
            $scope.deactivateUser(redemptionId, petsToArchive);
          }
        });
      });
    };

    $scope.deactivateUser = (redemptionId, petsToArchive) => {
      $scope.processing_deactivate_user_redemption_status = '';
      const payload = {
        deactivation: {
          redeem_points_id: redemptionId,
          pets_to_archive: petsToArchive
        },
      };
      $scope
        .deactivateUserProfile($http, ENV, $rootScope.userId, payload)
        .then((res) => {
          $scope.$apply(() => {
            $scope.initData();
            $rootScope.refreshLoyaltyStatistics();
            $rootScope.getData();
            $scope.getUser($http, ENV, $rootScope.userId);
            //$rootScope.closeComponent({ shouldHardClose: !$rootScope.isUserRoute });
            $rootScope.onDisplayDeactivationDetail({
              userId: $rootScope.userId,
              deactivationId: res.id,
            });
          });
        })
        .catch((error) => {
          $scope.processing_deactivate_user = false;
          if (error.data['deactivation']) {
            $scope.$apply(() => {
              $scope.errors = error.data['deactivation'];
            });
            return;
          }
          const errors = error.data['deactivation'];
          let result = [];
          if (errors) {
            result = Object.keys(errors)
              .map((key) => {
                const keyString = key
                  .split('_')
                  .map((item) => $scope.capitalize(item))
                  .join(' ');
                const value = errors[key];
                if (Array.isArray(value)) {
                  return value.map((x) => `${keyString}: ${x}`);
                }
                return `${keyString}: ${errors[key]}`;
              })
              .flat(1);
          } else {
            result.push('Something went wrong. Please try again.');
          }

          $scope.$apply(() => {
            $scope.errors = result;
          });
        });
    };

    $scope.close = () => {
      $rootScope.closeComponent({ shouldHardClose: !$rootScope.isUserRoute });
      $rootScope.getData();
      $rootScope.refreshUser();
    };

    $scope.$watch('subComponent', (newValue, oldValue) => {
      if (oldValue === 'deactivate-user') {
        $scope.initData();
        if (!$rootScope.isUserRoute) {
          const e = document.getElementById('redeemed-user-name_value');
          if (e) {
            e.value = '';
            angular.element(e).triggerHandler('input');
          }
          $scope.setActiveUser({});
          $scope.setActiveUserInfo({});
        }
      }
    });

    const petActiveListener = $scope.$watch('pets', () => {
      if (!isEmpty($scope.pets)) {
        $scope.active_pets = $scope.pets.filter((pet) => {
          if (!pet.is_active) {
            return false;
          }
          return true;
        });
      }
    });

    $scope.init();
    $scope.$on('$destroy', () => {
      $scope.unsubscribe();
      $scope.displayRedemptionOption = false;
      $scope.processing_deactivate_user_redemption = false;
      $scope.processing_deactivate_user = false;
      $scope.processing_deactivate_user_redemption_status = '';
      $interval.cancel(redemptionPromise);
      $scope.pets_to_archive = [];
      $scope.active_pets = [];
      petActiveListener();
    });
  })
  .directive('deactivateUser', () => {
    return {
      templateUrl: 'templates/v2/deactivate-user.html',
    };
  });
